import * as React from 'react'

import { marketApi } from '@envato/foundation-types'
import { config } from '../../../../common/config'
import { IItem } from '../../../../typings/searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'

import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import Button from '../../button'

import * as styles from './featuredAuthorBlock.module.css'

interface ICta {
  url: string
  title: string
}

interface IProps {
  data: IItem[]
  title: string
  subtitle?: string
  author: marketApi.IFeaturedAuthor
  cta: ICta
}

const FeaturedAuthorBlock = ({
  title,
  subtitle,
  data,
  author,
  cta
}: IProps) => {
  const defaultAvatarImgSrc = `${
    config.assets.PUBLIC_PATH
  }/images/default-user.jpg`

  const avatarSrc = (author && author.profile_image_url) || defaultAvatarImgSrc

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <ItemCardsLayout viewType="grid" className={styles.grid}>
          <ItemCardsLayout.CardArea className={styles.textArea}>
            <header>
              <h2 className={styles.title}>{title}</h2>

              <div className={styles.textAreaInner}>
                <div className={styles.author}>
                  <img
                    className={styles.authorImage}
                    src={avatarSrc}
                    alt={author.username}
                  />

                  <div className={styles.authorDetail}>
                    <h3 className={styles.authorTitle}>{author.username}</h3>
                    <p>
                      {author.country && `${author.country}, `}Member since{' '}
                      {author.member_since}
                    </p>
                    {author.portfolio_path && (
                      <Button
                        className={styles.leftButton}
                        type={Button.Type.Primary}
                        href={cta.url}
                        onClick={() =>
                          reportBlockClick('Featured Author', {
                            eventLabel: 'View profile'
                          })
                        }
                      >
                        {cta.title}
                      </Button>
                    )}
                  </div>
                </div>

                <p className={styles.subtitle}>{subtitle}</p>
              </div>
            </header>
          </ItemCardsLayout.CardArea>

          {data.map((item, index) => (
            <ItemCardsLayout.CardArea key={item.id}>
              <ItemCard
                listName="Home page: featured author"
                item={item}
                key={item.id}
                index={index}
                viewType="grid"
              />
            </ItemCardsLayout.CardArea>
          ))}
        </ItemCardsLayout>

        <Button
          type={Button.Type.Primary}
          className={styles.lowerButton}
          href={cta.url}
          onClick={() =>
            reportBlockClick('Featured Author', {
              eventLabel: 'View profile'
            })
          }
        >
          {cta.title}
        </Button>
      </div>
    </section>
  )
}

export default FeaturedAuthorBlock
